<template>
    <transition name="fade" mode="out-in">

    <div class="page-container">

        <!--div class="tray"></div-->
        <div class="content">
            <!--h1 v-if="user">{{ user.email }}</h1>
            <button class="button sign-out" @click="signout">Sign out</button-->

            <div class="parent">
                <!-- <div class="dash-item div1 dash-item-recents">
                    <Recent :user="userRef" :claims="claims" title="Leaderboard" />
                </div> -->
               <!--  <div class="dash-item div2 dash-item-badges">
                    <Badges :user="userRef" :claims="claims" :modCount="modCount" title="Badges" />
                </div> -->
               <!--  <div class="dash-item div1 dash-item-upnext">
                    <UpNext :user="userRef" :claims="claims" title="Modules" />
                </div> -->
                <div class="dash-item div4 dash-item-profile">
                    <Profile :user="userRef" :claims="claims" title="Profile" :signout="signout" />
                </div>
                <div class="dash-item div6 dash-item-total">
                    <Total :user="userRef" :claims="claims" :modCount="modCount" title="Total Progress" />
                </div>
                <div class="dash-item div5 dash-item-welcome">
                    <Welcome :user="userRef" :claims="claims" />
                </div>
            </div>
        </div>
    </div>
    </transition>
</template>

<script>
import firebase from "firebase";
import Welcome from "@/components/user_dash/Welcome";
import Profile from "@/components/user_dash/Profile";
import Total from "@/components/user_dash/Total";
//import Recent from "@/components/user_dash/Recent";
//import Badges from "@/components/user_dash/Badges";
//import UpNext from "@/components/user_dash/UpNext";
import store from '../store';

//const POST_LOGOUT_REDIRECT_URI = 'https://hbrc-18a6e.web.app';
//const ISSUER = 'https://hbrconsulting.okta.com/oauth2/default';
//const ISSUER = 'https://dev-347385.okta.com/oauth2/default';

export default {
    name: 'UserDash',
    components: {
        Welcome,
        Profile,
        Total,
        //Recent,
        //Badges,
        //UpNext,
    },
    data() {
        return {
            modCount: null,
            user: null,
            userRef: {
                progress: {
                    advisory: null,
                    managed_services: null,
                    operations: null,
                    total: null
                },
                completed: []
            },
            claims: {},
            clock: null
        };
    },
    created() {
        var self = this;
        //console.clear();
        //console.log('BEGIN CLOCK FOR DASHBOARD');
        self.startClock();

        var jirate = false;
        this.clock = setInterval(() => {
            jirate = !jirate;
            //console.log(( jirate ? 'tick' : 'tock' ));
            self.tick();
        }, 1000);
    },
    mounted() {
        //store.commit('finish');
        store.commit('dashMod', '');
        store.commit('moduleClick');

        if(store.state.finished) {
            //this.$confetti.start();
        }

        this.fetchUser();
        //console.clear();
        //console.log(this.$auth);
        //console.clear();

        //console.log('dashmod: ', store.state.dashMod);

        //console.log();
        //console.log('Current user: ', store.state.user);
        //console.log();
    },
    destroyed() {
        var self = this;
        self.stopClock();

        //console.log('PULLING NEW TIME OBJ FROM STATE AND PUSHING TO BACKEND.....');

        /*var fireRef = firebase.firestore().collection('users');
        console.log(fireRef.doc(self.claims.uid));*/
    },
    computed: {
        finished() {
            return store.state.finished;
        }
    },
    methods: {
        startClock() {
            this.clockActive = true;
        },
        stopClock() {
            this.clockActive = false;
            clearInterval(this.clock);
        },
        tick() {
            store.commit('tock', 'dashboard');
        },
        async fetchUser() {
            var self = this;

            await firebase.auth().onAuthStateChanged((userAuth) => {
                console.log('user obj?: ', userAuth);

                
                //console.clear();
                console.log('fetching user...');
                
                self.claims = store.state.user;
                console.log('current global user: ', self.claims);

                self.bindData();
            });

            //console.log('checking if user exists...', firebase.auth().currentUser);


            // Confirm the link is a sign-in with email link.
            /*if (firebase.auth().isSignInWithEmailLink(window.location.href)) {
            // Additional state parameters can also be passed via URL.
            // This can be used to continue the user's intended action before triggering
            // the sign-in operation.
            // Get the email if available. This should be available if the user completes
            // the flow on the same device where they started it.
            var email = window.localStorage.getItem('emailForSignIn');
            if (!email) {
                // User opened the link on a different device. To prevent session fixation
                // attacks, ask the user to provide the associated email again. For example:
                email = window.prompt('Please provide your email for confirmation');
            }
            // The client SDK will parse the code from the link for you.
            firebase.auth().signInWithEmailLink(email, window.location.href).then(function(result) {
                // Clear email from storage.
                window.localStorage.removeItem('emailForSignIn');
                // You can access the new user via result.user
                // Additional user info profile not available via:
                // result.additionalUserInfo.profile == null
                // You can check if the user is new or existing:
                // result.additionalUserInfo.isNewUser

                console.log('USER SUCCESFULLY LOGGED IN: ', result.user);
                console.log('Brand new user?: '. result.additionalUserInfo.isNewUser);
                self.claims = result.user;

                self.bindData();

                })
                .catch(function(error) {
                // Some error occurred, you can inspect the code: error.code
                // Common errors could be invalid email and invalid or expired OTPs.

                    console.log('invalid email?', error);
                });
            } else {
              firebase.auth().onAuthStateChanged((user) => {
                console.log('user?: ', user);
                if(user) {
                    self.claims = user;
                    self.bindData();
                }
              });
            }*/

            /*if(firebase.auth().currentUser) {
                console.log('user indeed exists!');
                self.claims = firebase.auth().currentUser;
                console.log('CLAIMS: ', self.claims);
                self.bindData();
            } else {
                console.log('user does not exist :( redirecting to login...');          
            }

            /*firebase.auth().onAuthStateChanged((user) => {

                console.log('checking if user exists...');

                if(user) {
                    console.log('user indeed exists!: ', user);
                    self.claims = user;
                    console.log('CLAIMS: ', self.claims);
                    self.bindData();
                } else {
                    console.log('user does not exist :( redirecting to login...');
                }
            });*/
        },
        /*async setup() {
            console.log('grabbing claims');
            var authResult = await this.$auth.parseHash();
            
            console.log(authResult);
            
            //this.claims = authResult;
            console.log(this.claims);
            this.bindData();
        },*/
        /*async isAuthenticated() {
            this.authenticated = await this.$auth.isAuthenticated();
        },*/
        /*async logout() {
            console.log('logging out...');
            // read idToken before local session is cleared
            const idToken = await this.$auth.getIdToken();
            // clear local session
            await this.auth.logout();
            // clear remote session
            window.location.href = `${ISSUER}/v1/logout?id_token_hint=${idToken}&post_logout_redirect_uri=${POST_LOGOUT_REDIRECT_URI}`
        },*/
        signout() {
            firebase.auth().signOut().then(user => {
                // this.$store.commit("setUser", null);
                console.log("loggin out...");
                this.$router.push("/auth");
                console.log(user);
            });
        },
        /*
        
        there are certain things one can come to learn from the pursuit of mututal snogging and all the sensory lovelies that come with romantic companionship. 
        To express interest is a thing. To admit interest is another thing. To share interest is a sort of goal, but nobody has control over that. Don't die.
        
        */
        fetchData() {
          /*var self = this;

          var fireRef = firebase.firestore().collection("users");

          fireRef.doc(self.claims.sub).get().then((doc) => {
              self.userRef = doc.data();
              console.log('userRef: ', self.userRef);
          });*/
        },
        async bindData() {
            console.log('binding data..........');
            var self = this;
            var fireRef = firebase.firestore().collection('users');
            await fireRef.doc(self.claims.uid).get().then((doc) => {
                console.log('already exists?: ', doc.exists);
                if(doc.exists) { //pull ref data
                    console.log('doc exists');
                    console.log(doc.data());
                    self.userRef.progress.advisory = doc.data().progress.advisory;
                    self.userRef.progress.managed_services = doc.data().progress.managed_services;
                    self.userRef.progress.operations = doc.data().progress.operations;
                    self.userRef.progress.total = doc.data().progress.total;
                    self.userRef.completed = doc.data().completed;

                    //updating module completed count

                    let modCount = 0;

                    if(self.userRef.progress.advisory >= 100) {
                        modCount++;
                    }

                    if(self.userRef.progress.managed_services >= 100) {
                        modCount++;
                    }

                    if(self.userRef.progress.operations >= 100) {
                        modCount++;
                    }

                    self.modCount = modCount;

                    //console.clear();
                    //console.log('ayeeee... ', self.modCount);

                    //checking if anyone has reached 100% yet

                    if(self.userRef.progress.total >= 100) {
                        firebase.firestore().collection('winners').doc(self.claims.uid).set({
                            timestamp: Date.now(),
                            name: self.claims.displayName,
                            email: self.claims.email
                        });

                        //--- all the other winner handling stuff --- (smallest timestamp == first to complete)

                        console.log("CONGRATS! You've completed all modules");
                        console.log("*queue the confetti*");
                    }
                }
                else { //create ref data
                    console.log("doc doesn't exist... creating doc");
                    fireRef.doc(self.claims.uid).set({
                        email: self.claims.email,
                        displayName: self.claims.displayName,
                        completed: [],
                        photo: 'https://firebasestorage.googleapis.com/v0/b/hbrc-18a6e.appspot.com/o/Profiles%2Fprofile-blank.svg?alt=media&token=1aaf1581-f30b-4027-adb3-b09e627d145f',
                        progress: {
                            advisory: 0,
                            managed_services: 0,
                            operations: 0,
                            total: 0,
                            average: 0
                        },
                        time_spent: {
                            dashboard: 0,
                            advisory: 0,
                            managed_services: 0,
                            operations: 0,
                            total: 0,
                            average: 0
                        }
                    });
                }
            });

            //console.log('data successfully binded.');
        }
    }
};
</script>

<style scoped lang="scss">
@import '../assets/global-styles/variables.scss';

.blur {
    filter: blur(48px);
}

.tray {
    background: white;
    position: absolute;
    height: 120px;
    bottom: 0px;
    width: 100%;
    margin: 0px;
    padding: 0px;
    z-index: -1;
}

.page-container {
    background: $colorBackdrop;
    overflow: hidden;
}
.content {
    margin-top: $navHeight;
    width: 100%;
    padding-left: $gap;
    padding-right: $gap;
    height: calc(100vh - #{$navHeight} - #{$gap} * 2); //interpolate variables
}
.parent {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(2, 1fr);
    grid-gap: $gap;
    width: 100%;
    height: 100%;
}
.dash-item {
    background: #ffffff;
    border-radius: $rad;
    opacity: 0;
}
.div1 { //recent modules
    grid-area: 1 / 1 / 3 / 3;  // Use 1 / 5 / 4 / 7 old: 1 / 5 / 3 / 7;
    animation: flyin 1s ease forwards;
    animation-delay: 0.8s;
    //box-shadow: $softerShadow;
    overflow: auto;
}
.div2 { //badges
    grid-area: 3 / 3 / 4 / 5;  //Use 3 / 3 / 4 / 5 old:  3 / 5 / 4 / 7;
    animation: flyin $pageTransitionSpeed ease forwards;
    animation-delay: 1s;
    background: transparent !important;
}
.div3 { //up next
    grid-area: 4 / 1 / 5 / 7;
    background: rgba(0,0,0,0);
    animation: flyin $pageTransitionSpeed ease forwards;
    animation-delay: 0.4s;
}
.div4 { //profile
    grid-area: 1 / 3 / 2 / 5; 
    height: 25%;
    animation: flyin $pageTransitionSpeed ease forwards;
    animation-delay: 0.2s;
    //box-shadow: $softerShadow;
}
.div6 { //total progress
    grid-area: 1 / 3 / 1 / 5; //Use 1 / 3 / 3 / 5  old: 1 / 3 / 4 / 5;
    animation: flyin $pageTransitionSpeed ease forwards;
    animation-delay: 0.6s;
    margin-top:25%;
    //box-shadow: $softerShadow;
}
.div5 { //welcome banner
    grid-area: 1 / 1 / 2 / 3; 
    background: rgba($colorBlue, 0.06);
    animation: flyin $pageTransitionSpeed ease forwards;
    //box-shadow: $softerShadow;
}
</style>